import request from '@/plugins/axios'


//通过文件编号获取面孔列表
export function listPeopleFaceByFileId(params) {
  return request({
    url: '/peopleFace/listPeopleFaceByFileId',
    method: 'get',
    params
  })
}

//删除面孔
export function deletePeopleFace(params) {
  return request({
    url: '/peopleFace/deletePeopleFace/' + params,
    method: 'get'
  })
}

//创建面孔
export function addPeopleFace(data) {
  return request({
    url: '/peopleFace/addPeopleFace',
    method: 'post',
    data
  })
}

//面孔关联人物
export function setPeopleFaceAccess(params) {
  return request({
    url: '/peopleFace/setPeopleFaceAccess',
    method: 'post',
    params
  })
}

//通过人物编号获取面孔列表
export function listPeopleFaceByPeopleId(params) {
  return request({
    url: '/peopleFace/listPeopleFaceByPeopleId',
    method: 'get',
    params
  })
}